import { render } from "./adopteVue.vue?vue&type=template&id=6115e482&scoped=true"
import script from "./adopteVue.vue?vue&type=script&lang=js"
export * from "./adopteVue.vue?vue&type=script&lang=js"

import "../assets/css/animauxnew.css?vue&type=style&index=0&id=6115e482&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6115e482"]])

export default __exports__